import { CashOfficeColumn } from "@/components/data-table/CashOfficeColumn";
import DataTable from "@/components/data-table/DataTable";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { ISODateFormat, STALE_TIME_INVOICE } from "@/constants";
import { UserContext } from "@/context/User/UserContext";
import { cn } from "@/lib/utils";
import { getInProgressInvoices } from "@/services/invoice-functions";
import { format, subDays } from "date-fns";
import React, { useContext } from "react";
import { DateRange } from "react-day-picker";
import { IoCalendarSharp } from "react-icons/io5";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const AdminInProgress = () => {
	const user = useContext(UserContext);

	const [date, setDate] = React.useState<DateRange | undefined>({
		from: subDays(new Date(), 3),
		to: new Date(),
	});
	const [isPopUpOpen, setIsPopUpOpen] = React.useState(false);

	const invoices = useQuery({
		queryKey: ["invoice", "inprogress", date?.from, date?.to],
		queryFn: () =>
			getInProgressInvoices(
				user?.accessToken!,
				ISODateFormat(date?.from!),
				ISODateFormat(date?.to!)
			),
		enabled: !!user?.accessToken && !!date,
		staleTime: STALE_TIME_INVOICE,
	});

	const navigate = useNavigate();

	return (
		<>
			<div className="flex flex-col sm:flex-row justify-between pb-4 sm:pb-0 border-b">
				<div>
					<h1 className="text-4xl font-bold mb-2">Ongoing Approvals</h1>
					<h3 className="text-zinc-600 font-light mb-4">
						Here are a list of claims that are currently being processed
					</h3>
				</div>
			</div>
			<div>
				<div className="flex justify-end py-2">
					<Popover open={isPopUpOpen} onOpenChange={setIsPopUpOpen}>
						<PopoverTrigger asChild>
							<Button
								id="date"
								variant={"outline"}
								className={cn(
									"w-[300px] justify-start text-left font-normal",
									!date && "text-muted-foreground"
								)}
							>
								<IoCalendarSharp className="mr-2 h-4 w-4" />
								{date?.from ? (
									date.to ? (
										<>
											{format(date.from, "LLL dd, y")} - {format(date.to, "LLL dd, y")}
										</>
									) : (
										format(date.from, "LLL dd, y")
									)
								) : (
									<span>Pick a date</span>
								)}
							</Button>
						</PopoverTrigger>
						<PopoverContent className="w-auto p-2" align="start">
							<Select
								onValueChange={(value) => {
									setDate({
										from: subDays(new Date(), parseInt(value)),
										to: new Date(),
									});
									// setIsPopUpOpen(false);
								}}
							>
								<SelectTrigger>
									<SelectValue placeholder="Select" />
								</SelectTrigger>
								<SelectContent position="popper">
									<SelectItem value="0">Today</SelectItem>
									<SelectItem value="1">Yesterday</SelectItem>
									<SelectItem value="3">Past 3 days</SelectItem>
									<SelectItem value="7">Past week</SelectItem>
								</SelectContent>
							</Select>
							<Calendar
								initialFocus
								mode="range"
								defaultMonth={date?.from}
								selected={date}
								onSelect={setDate}
								numberOfMonths={1}
							/>
							<Button
								className="w-full hover:bg-primary/30"
								onClick={() => setIsPopUpOpen(false)}
							>
								Confirm
							</Button>
						</PopoverContent>
					</Popover>
				</div>
				{invoices.data ? (
					<DataTable
						columns={CashOfficeColumn}
						data={invoices.data}
						rowClick={(id: number) => navigate(`/admin/${id}`)}
						rowId="invoicemasterid"
						searchColumn="raisedby"
					/>
				) : null}
				{invoices.isLoading ? (
					<div className="align-centre">
						<h5 className="text-center">Loading claims, please wait...</h5>
					</div>
				) : invoices.isError ? (
					<div className="align-centre">
						<h5 className="text-center">Error showing claims.</h5>
					</div>
				) : (
					invoices.data &&
					invoices.data.length === 0 && (
						<div className="align-centre">
							<h5 className="text-center">No claims found</h5>
						</div>
					)
				)}
			</div>
		</>
	);
};

export default AdminInProgress;
